import React, { Component } from 'react'
import { Tab, Tabs } from 'material-ui/Tabs'
import Paper from 'material-ui/Paper'
import Participants from './Participants'
import Chat from '../BreakOutTabs/Chat'
import { FormattedMessage } from 'react-intl'

const lightGreen = '#29B87A'
const lightGray = '#afb8c5'

export default class BreakOutTabs extends Component {
  state = {
    index_0: lightGreen,
    index_1: lightGray,
    index_2: lightGray
  }
  handleTabChange = (e) => {
    const index = e.props.index
    switch (index) {
      case 0:
        this.setState({
          index_0: lightGreen,
          index_1: lightGray,
          index_2: lightGray,
          index_3: lightGray,
          index_4: lightGray,
          index_5: lightGray
        })
        break
      case 1:
        this.setState({
          index_1: lightGreen,
          index_0: lightGray,
          index_2: lightGray,
          index_3: lightGray,
          index_4: lightGray,
          index_5: lightGray
        })
        break
      case 2:
        this.setState({
          index_2: lightGreen,
          index_0: lightGray,
          index_1: lightGray,
          index_3: lightGray,
          index_4: lightGray,
          index_5: lightGray
        })
        break
      default:
        console.log('default')
    }
  }

  render () {
    let raise_staging = false
    if (this.props.raiseList) {
      this.props.raiseList.map((val) => {
        if (val.raise) {
          raise_staging = true
        }
      })
    }

    return (
      <Paper className='h-100'>
        <Tabs
          tabTemplateStyle={{backgroundColor: '#F9F9F9'}}
          inkBarStyle={{background: '#29B87A', height: 3}}
          tabItemContainerStyle={{
            backgroundColor: '#FFFFFF',
            color: '#29B87A',
            borderBottom: '1px solid #d9d9d9'
          }}>
          <Tab
            onActive={this.handleTabChange}
            buttonStyle={{color: this.state.index_0}}
            label={<FormattedMessage id='main.textchat'/>}>
            <div style={{height: '85vh'}}>
              <Chat location={this.props.location} handleChat={this.props.handleChat} user_name={this.props.user_name}
                    chat={this.props.chat}/>
            </div>
          </Tab>

          <Tab
            onActive={this.handleTabChange}
            buttonStyle={{color: this.state.index_1}}
            label={<FormattedMessage id='main.participants'/>}>
            <div style={{height: '85vh'}}>
              {(this.props.mode == 'seminar') ?
                (<Participants
                  location={this.props.location}
                  participants={this.props.remoteList}
                  handleListClick={this.props.handleListClick}
                  purpose='seminarParticipants'/>)
                : (this.props.mode == 'breakout' && !this.props.break_join) ?
                  (<Participants
                    location={this.props.location}
                    participants={this.props.remoteList}
                    user_role={this.props.user_role}
                    groupList={this.props.groupList}
                    handleListClick={this.props.handleListClick}
                    purpose='participants'
                    unassigned={false}/>) : (this.props.mode == 'breakout' && this.props.break_join) ?
                    (<Participants
                      location={this.props.location}
                      participants={this.props.groupListObj[this.props.group]}
                      groupList={this.props.groupList}
                      user_role={this.props.user_role}
                      handleListClick={this.props.handleListClick}
                      purpose='seminarParticipants'
                      unassigned={false}/>) : (null)}
            </div>
          </Tab>
          {!(this.props.mode == 'breakout' && this.props.break_join) && <Tab
            onActive={this.handleTabChange}
            buttonStyle={{color: this.state.index_2}}
            label={(this.props.mode == 'seminar') ? (<FormattedMessage id='main.questions'/>) : (
              <FormattedMessage id='main.unassigned'/>)}>
            <div style={{height: '85vh'}}>
              {(this.props.mode == 'seminar') ?
                (<Participants
                  location={this.props.location}
                  participants={this.props.raiseList}
                  raise_staging={raise_staging}
                  handleListClick={this.props.handleListClick}
                  purpose='questions'/>) : (this.props.mode == 'breakout' && !this.props.break_join) ?
                  (<Participants
                    location={this.props.location}
                    participants={this.props.remoteList}
                    unassigned={true}
                    groupList={this.props.groupList}
                    handleListClick={this.props.handleListClick}
                    user_role={this.props.user_role}
                    purpose='participants'/>) : (null)}
            </div>
          </Tab>}

        </Tabs>
      </Paper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SeminarTabs/SeminarTabs.js